import { appRouterPaths } from "@/services/navigation";
import { IdeasPage } from "@/pages/IdeasPage";
import type { RouteProps } from "react-router-dom";

export const ideasPageRoute: RouteProps = {
  path: appRouterPaths.ideas,
  element: <IdeasPage />,
};
